import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo */}
          <img 
            src="/images/logo-white.svg" 
            alt="Coupang Play Entertainment Logo"
            className="footer-logo"
          />
          
          {/* Privacy Policy */}
          <div className="footer-privacy">
            <a
              href="https://privacy.coupang.com/ko/land/cpe/"
              target="_blank"
              rel="noopener noreferrer"
            >
              개인정보 처리방침
            </a>
          </div>

          {/* Contact Section */}
          <div className="footer-contact">
            <span className="footer-contact-label">섭외/제작 문의</span>
            <span className="footer-contact-email">management@cpent.com</span>
          </div>
          <div className="footer-contact">
            <span className="footer-contact-label">제보 및 신고</span>
            <span className="footer-contact-email">report@cpent.com</span>
          </div>
          
          {/* Company Info */}
          <div className="footer-company-info">
            <span>씨피엔터터테인먼트</span>
            <span className="footer-separator" />
            <span>대표자명 : 최종욱</span>
            <span className="footer-separator" />
            <span>사업자등록번호 : 677-81-03126</span>
          </div>
          
          {/* Copyright */}
          <p 
            className="footer-copyright"
          >
            Copyright ⓒ CP ENTERTAINMENT All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
